import { render, staticRenderFns } from "./DiscountTable.vue?vue&type=template&id=7854471e"
import script from "./DiscountTable.vue?vue&type=script&lang=js"
export * from "./DiscountTable.vue?vue&type=script&lang=js"
import style0 from "./DiscountTable.vue?vue&type=style&index=0&id=7854471e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports